<template>
<div>
<h3>Donating or Requesting Human Milk</h3>
<br />
  <div class="donatingAndRequesting">
    <div width="100%" height="3550px" align="top">
    <div class="latestInfoToc">
    <ul>
      <li>
      <router-link to="/chapters"
      title="Click here to go directly to this post">
      Facebook Chapters</router-link>
    </li>
<li>
<a href="https://www.eatsonfeetsforum.com"
  target="_blank"
  title="Click here to go directly to this post">
  Forum</a>
</li>
<li>
<a href="https://www.mobileapp.app/to/MPBfY8Y?ref=cl"
  target="_blank"
  title="Click here to go directly to this post">
  App</a>
</li>
<li>
<a href="https://www.getsafeonline.org/personal/articles/social-networking-sites/"
  target="_blank"
  title="Click here to go directly to this post">
  Safe Social Networking</a>
</li>
  </ul>
  </div>
  </div>
      <img class="borderedImage borderedImageLeft" src="../assets/Donating_Requesting.jpg" />
<p>The Eats on Feets network operates on Facebook, with a local chapter for many areas, and on a Forum, which also has an App.</p>
<p>Our Facebook community groups are public, though posts can be made anonymously. We believe that there is safety in transparency and we believe that screening and approving members gives a false sense of security to our members.</p>
<p>Our Forum is accessible via registration only and free. Once signed up on the forum, members can message each other or connect via phone or social media.</p>
<p><strong>Eats on Feets does not screen donors and recipients, nor do we match anyone. Our network is used for milksharing without third-party involvement. We can only accept requests from those who are legally or medically responsible for the baby in need and offers from the donors themselves.</strong></p>
<p>Before posting, please read the 4 Pillars for specifics about screening donors or recipients and the safe handling of donated breastmilk. The Forum also has an app for your convenience!
</p>
<br />
<h4>Posting Offers &amp; Requests on Facebook</h4>
<br />
<ul>
<li>Go to your local Eats on Feets Page on Facebook and follow it for safe milksharing information.</li>
<li>The link to your Community Group is in the featured post at the top of the Page.</li>
<li>If there is no Community Group for your area, please join our Forum.</li>
<li>Please read the group rules for participating upon joining.</li>
<li>Check the posts for current offers and requests. Respond to the posts that suit your situation and let the poster know in the comments that you sent them a private message so they know to look for it.</li>
<li>Please practice safe social networking: Do not engage if something does not feel right; do not share private information in the group, and do not send people any money for milk, gas, parts, shipping, etc.</li>
<li>If you do not find a match that is suitable to you, post your offer or request. Please include some background information regarding your general location, whether this is an ongoing or temporary request/donation, the age of your child, any special diet considerations, the best way to contact you, etc.</li>
<li>If you do not see your post in the group, please make sure you followed the rules or it may have been declined or removed.</li>
<li>Regularly check for comments on your post. Facebook notifications can be delayed or unreliable. It is up to donors and recipients to connect with each other, check their post, and follow up with potential leads.</li>
<li>If you have not received a response to your post, please feel free to post again. Please feel free to also post in a neighboring Community Group.</li>
<li>Please send a message to your local Page if you need further assistance.</li>
</ul>
<br />
<h4>Posting Offers &amp; Requests on the Forum</h4>
<br />
<ul>
<li>Signing up: Profiles must have a full name, a social media field or phone number, and be public so that members can see and verify each other.</li>
<li>Please read the Rules & Guidelines for participating upon joining.</li>
<li>Find your local forum (state, province, or country) and look for offers or requests.</li>
<li>Please practice safe social networking: Do not engage if something does not feel right; do not share private information in the group, and do not send people any money for milk, gas, parts, shipping, etc.</li>
<li>If there are no offers or requests near you, please create a new post with offer or request as well as your approximate location in the title. This makes it easier for members to find donors or recipients near them.</li>
<li>Please comment on a post before connecting privately. This helps with mutual verification.</li>
<li>You can follow your forum(s) of choice and stay up to date on responses.</li>
<li>Please contact us on the forum if you need further assistance.</li>
</ul>
<br />
  </div>
  </div>
</template>

<script>
export default {
  name: 'DonatingAndRequesting'
}
</script>
